import {makeStyles} from '@material-ui/core/styles'
import AccountAvatar from './AccountAvatar'
import {Text} from '../../../1elements'
import { Reorder } from "framer-motion";

const AccountDetailAdmin = ({data, className}) => {
    const { cardId } = data
    const classes = useStyles()

    return (
        <Reorder.Item key={cardId} value={data} className={`${classes.root} ${className}`} >
            <AccountAvatar accountName={''} />
            <div className={classes.dataDiv}>
                <Text type={'h10'} className={classes.accountName}>[Account Name]</Text>
                <Text type={'p'}><b>Address</b>: </Text>
                <Text type={'p'}><b>City</b>: </Text>
                <Text type={'p'}><b>Province</b>: </Text>
                <Text type={'p'}><b>Postal Code</b>: </Text>
                <Text type={'p'}><b>Country</b>: </Text>
            </div>
        </Reorder.Item>
    )
}

export default AccountDetailAdmin

const useStyles = makeStyles((theme)=>({
    root: {
        width: '100%',
        height: '100%',
        gridColumn: 'span 4',
        gridRow: 'span 4',
        display: 'flex',
        alignItems: 'center',

    },
    dataDiv: {
        marginLeft: 20
    },
    accountName: {
        color: theme.palette.primary.accent
    },
}))